import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import {
  getCourseOptions,
  getSectionOptions,
  listAssignmentsOptions,
  listProjectsOptions,
} from "@/client/@tanstack/react-query.gen"
import InstructorSectionDashboard from "@/routes/-pages/InstructorSectionDashboard"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

const SECTION_TAB_PARAMS = ["assessments", "teams", "members", "grades"] as const
type SectionTabParam = (typeof SECTION_TAB_PARAMS)[number]

export const Route = createFileRoute("/instructor/course/$courseId/section/$sectionId")({
  validateSearch: (search: Record<string, unknown>): { tab?: SectionTabParam } => ({
    tab: SECTION_TAB_PARAMS.includes(search.tab as SectionTabParam) ? (search.tab as SectionTabParam) : undefined,
  }),
  loader: ({ params }) => {
    const { courseId, sectionId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getCourseOptions({ path: { course_id: courseId } })),
        queryClient.prefetchQuery(
          getSectionOptions({
            path: { course_id: courseId, section_id: sectionId },
          }),
        ),
        // Prefetch default tab (assessments) so it renders without loading state
        queryClient.prefetchQuery(listAssignmentsOptions({ path: { course_id: courseId } })),
        queryClient.prefetchQuery(listProjectsOptions({ path: { course_id: courseId } })),
      ]),
    )
  },
  component: InstructorSectionDashboard,
})
